module.exports = __webpack_public_path__ + "img/video-player/love@3x-9da0405e3fe646251b4fc9dba44ebdc1.png";